(function(){
  let debug = 0;
  const variationName = "BM Test 02 - Cart Page Suggestions";
  try {
    function observeSelector(selector, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var docContext = options.document || document;
      var processed = new WeakSet();
      var processElement = function processElement(el) {
        if (!processed.has(el)) {
          processed.add(el);
          callback(el);
          if (options.once) observer.disconnect();
        }
      };
      var observer = new MutationObserver(function () {
        docContext.querySelectorAll(selector).forEach(processElement);
      });
      docContext.querySelectorAll(selector).forEach(processElement);
      observer.observe(docContext, {
        childList: true,
        subtree: true
      });
      return observer; // ✅ Allow caller to manually disconnect
    }

    const cartBottomSection = `
      <div class="bm-cart-bottom-container">
        <div class="bm-cart-bottom-content">
          <div class="bm-cart-bottom-icon-text">
            <img class="bm-cart-bottom-icon" src="//tacticalelites.com/cdn/shop/files/free-shipping_72828624-9982-4b20-8c26-b5b193ff2969.avif?v=1787218156" alt="">
            <span class="bm-cart-bottom-text">Free Shipping</span>
          </div>
          <div class="bm-cart-bottom-icon-text">
            <img class="bm-cart-bottom-icon" src="//tacticalelites.com/cdn/shop/files/check-mark-circle_9b0f7cd6-34de-41e3-8754-68eb20677dbe.avif?v=1787218156" alt="">
            <span class="bm-cart-bottom-text">30 Day Money Back Guarantee</span>
          </div>
        </div>
        <div class="bm-cart-bottom-icons">
          <img src="//tacticalelites.com/cdn/shop/files/reassurance-strip_97f1b5bc-f5de-4786-baee-e540fc5d3230.avif?v=1787218156" alt="">
        </div>
      </div>
    `;

    // Insert cart bottom content
    function insertCartBottomContent () {
      if(document.querySelector('.bm-cart-bottom-container')) return;
      const discountWrapper = document.querySelector('.upcart-footer .govx-discount-wrapper');
      discountWrapper?.insertAdjacentHTML('afterend', cartBottomSection);
    }

    if(!window.cartPageSuggestions) {
      window.cartPageSuggestions = true;
      observeSelector('.upcart-footer .govx-discount-wrapper', insertCartBottomContent);
    }

  } catch (e) {
    if (debug) console.log(e, "error in Test " + variationName);
  }
})();